import * as React from 'react';
import { Modal } from '../../../components/containers/Modal';
import { GetMe_me_organizations } from '../../../models/legacy-graphql';
import { ButtonColorsEnum } from '../../../constants/button-colors';
import { SettingsTeamMemberStatusEnum } from '../../../constants/team-members';
import { SettingsTeamMember } from '../../../models/settings-pages';

export type RemoveTeamMemberModalViewProps = {
  user: SettingsTeamMember;
  onClose: () => void;
  onSubmit: () => void;
  submitted: boolean;
  selectedOrganization: GetMe_me_organizations | null;
};

export const RemoveTeamMemberModalView = (props: RemoveTeamMemberModalViewProps): JSX.Element => {
  const isInvited: boolean = props.user?.status === SettingsTeamMemberStatusEnum.INVITED;
  const modalTitle: string = isInvited ? 'Revoke Invite' : 'Remove Team Member';
  const buttonTitle: string = isInvited ? 'Revoke Invite' : 'Remove Member';
  const modalMessage: string = isInvited
    ? `This person won't be able to join ${props.selectedOrganization?.name} through the link they received any more`
    : `Are you sure you want to remove ${props.user?.name} from ${props.selectedOrganization?.name}? This will have consequences...`;

  return (
    <Modal
      closeOnClickOutside={!props.submitted}
      closeOnEsc={!props.submitted}
      onClose={props.onClose}
      showCloseIcon={!props.submitted}
      title={modalTitle}
      primaryButtonTitle={buttonTitle}
      primaryButtonAction={props.onSubmit}
      primaryButtonColor={ButtonColorsEnum.alert}
      primaryButtonDisabled={props.submitted}
      primaryButtonLoading={props.submitted}>
      <div>{modalMessage}</div>
    </Modal>
  );
};
